import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { SubscriptionService } from '../../../services/subscription.service';

@Component({
  selector: 'app-cancel-subscription',
  templateUrl: './cancel-subscription.component.html',
  styleUrls: ['./cancel-subscription.component.scss']
})
export class CancelSubscriptionComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<CancelSubscriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any, private subscriptionService: SubscriptionService) { }

  ngOnInit() {
  }

  confirm(){
    this.subscriptionService.cancelSubscription(this.data.subscription_id).subscribe(res=>{
      this.dialogRef.close(true);
    })
  }

  close(){
    this.dialogRef.close(false);
  }

}
